module.exports = __webpack_public_path__ + "assets/password.9173da92.svg";